<template>
<nav aria-label="breadcrumb" class="breadcrumb-area">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">プライバシーポリシー</li>
  </ol>
</nav>
<div class="container">
    <div class="top--section">
        <Privacy/>
    </div>
</div>
</template>
<script setup>
import Privacy from "@/components/Static/Privacy.vue";
</script>

<style>
.section-box .section-txt ol.deci1 li {
  text-indent:-18px;
  padding-left:18px;
  padding-bottom:10px;
  line-height:180%;
}

.section-box .section-txt ol.deci2 li {
  text-indent:-37px;
  padding-left:37px;
  padding-bottom:10px;
  line-height:180%;
}
</style>
